// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: "Barlow";
    background-color: #ffffff;
  }

  
  button {
    font-family: "Barlow Semi Condensed", system-ui;
    font-weight: 400;
    font-style: normal;
    font-size: 2em;
  }

  span {
    font-family: "Barlow Semi Condensed", system-ui;
    font-weight: 400;
    font-style: normal;
    font-size: 1.5em; /*2em*/
  }

  input {
    font-family: "Barlow Semi Condensed", system-ui;
    font-weight: 400;
    font-style: normal;
    font-size: 2em;
    height: 5vmin;
  }

  h1 {
    font-size: 3em;
  }

  h2 {
    font-family: "Barlow", system-ui;
    font-size: 1.5em;
    font-weight: 600;
    font-style: italic;
    color: #555;
    border-bottom: 2px solid #ccc;
    padding-bottom: 0.25em;
    margin-block-start: 0.1em;
    margin-block-end: 0.1em;

  }

  .list {
    font-family: sans-serif;
    margin: 0;
    padding: 20px 0 0;
  }

  .list>li {
    display: block;
    background-color: #fff;
    padding: 10px;
    /* box-shadow: inset 0 2px 0 #ccc; */
  }


  .precontainer {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .container {
    display: flex;
    justify-content: space-between;
  }
  .bowl_game_title
  {
    font-family: "Barlow Semi Condensed", system-ui;
    font-weight: 500;
    font-style: normal;
    color: #999999;
    font-size: 1.0em; /*2em*/
    /* padding-top: 0.5em; */
    padding-bottom: 0.5em;
  }

  .search {
    font-size: 1.25em;
    width: 92%;
    height: 0.3cm; 
    padding: 0.25cm;
    /* margin-left: 0.25cm;
    margin-right: 0.25cm;
    display: inline-block; */
  }

  .clear-search-button {
    position: absolute;
    right: 1.15cm;
    width: 0.6cm;
    height: 0.6cm;
    font-size: 0.4cm;
    text-align: center;
    line-height: 0.6;
    font-weight: 800;
    padding: 0;
    border-radius: 0.3cm;
    border-width: 0px;
    color: #ffffff;
    background-color: #999999;
    /* border-color: #333333; */
    display: none;
}
.clear-search-button.show {
    display: block;
}
  .home_team_name {
    flex-basis: 25%;
    /* adjust width */
  }
  .away_team_name {
    flex-basis: 25%;
  }
  .away_team_shortname {
    display: none;
  }
  .home_team_shortname {
    display: none;
  }

  /* .home_team_mascot {
    flex-basis: 25%;
  }

  .home_team_mascot {
    flex-basis: 25%;
  } */

  .at_sign {
    flex-basis: 5%;
  }
  .home_team_logo_img {
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }
  .away_team_logo_img {
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }

  .time {
    flex-basis: 10%;
    /* adjust width */
  }
  .timelink {
    text-decoration: underline;
    text-decoration-color: #d8d8d8;
    color: inherit;
  }

  .watchability {
    flex-basis: 15%;
    /* adjust width */
    margin-left: auto;
    /* text-align: center; */
    /* right-justify */
  }

  .br_mobile_only {
    display: none; 
  }

  .filterbutton {
    height: 1.25cm;
    width: 1.25cm;
    /* margin-left: 2vmin; */
    padding: 0;
    margin: 0.1cm;
    font-size: 1.0em;
    -webkit-box-align: center;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.2cm;
  }


.changeWeekButton {
    font-family: "Barlow Semi Condensed", system-ui;
    font-weight: 400;
    font-style: normal;
    font-size: 2em;
    background-color: #448811;
    color: #ffffff
}

.weekLabelSpan {
    font-family: "Barlow Semi Condensed", system-ui;
    font-weight: 400;
    font-style: normal;
    padding-left: 0.25em;
    padding-right: 0.25em;
    font-size: 1.0em;
    text-align: center;
    width: 3cm;
}

.viewFilterSelect {
    font-family: "Barlow Semi Condensed", system-ui;
    font-weight: 400;
    font-style: normal;
    padding-left: 0.25em;
    padding-right: 0.25em;
    font-size: 1em;
    height: 1.25cm;
    border-radius: 0.2cm;
    -webkit-border-radius: 0.2cm;
    color: #111
}

.top-panel {
    position: fixed;
    display: flex; 
    flex-direction: row; 
    top: 0;
    left: 0;
    height: 2cm;
    width: 100%;
    background-color: #333576;
    color: #eee;
    padding: 0px;
    padding-left: 0.5cm;
    padding-right: 0.5cm;
    margin: 0px;
    align-items: center;
    border-radius: 0;
    z-index: 1;
    }
.fixed-element {
    position: fixed;
    display: flex;
    bottom: 0;
    /* top: 93%; */
    height: 1.75cm;
    left: 0;
    width: 100%;
    background-color: #ccc;
    /* padding: 10px; */
    /* padding-top: 10px; */
    /* padding-bottom: 0px; */
    margin: 0;
    border-top: 1px solid #818181;
    z-index: 1;
    font-size: 2em;
    
    
    }

.fe_div_container {
    display: inline-flex;
    align-items: center;
    height: 100%;
    vertical-align: middle;
    padding-right: 0.15cm;
    /* padding: 15px; */
    }
    
.list-container {
    position: absolute;
    /* top: 1.9cm;
    bottom: 1.7cm; */
    left: 0;
    right: 0;
    overflow-y: auto;
    padding: 20px;
    margin-top: 0.1cm;
    padding-top: 1.5cm; /* remove default padding-top */
    padding-bottom: 1.8cm;
    }

.w2w-title {
    font-family:'Barlow'; 
    font-size:3em; 
    font-weight:700; 
    flex-basis: 60%; 
    display:inline-block
}



/* iPAD */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
	span {
        font-size: 1.5em; /*2em*/
        /* background-color: #ccffff; */
      }


      .search {
        width: 90%;
      }

      .clear-search-button {
        right: 0.9cm;
      }
}

/* @media only screen and (min-device-height: 768px) and (max-device-height: 1024px) and (orientation: landscape) {
	span {
        font-size: 1.5em; 
        background-color: #ccffff;
      }
} */

/* iPhone */
@media only screen and (max-device-width: 480px) and (orientation: portrait) {
    span {
        font-size: 1em; /*2em*/
        /* background-color: #ffeeff; */
      }
    .filterbutton {
        height: 2em;
        width: 2em;
        font-size: 1.7em;
        color: #111
      }

    input {
        height: 2.5em;
      }

      .weekLabelSpan {
        font-family: "Barlow Semi Condensed", system-ui;
        font-weight: 300;
        font-style: normal;
        padding-left: 0.25em;
        padding-right: 0.25em;
        font-size: 0.7em;
        width: 2cm;
    }
    .viewFilterSelect {
        font-family: "Barlow Semi Condensed", system-ui;
        font-weight: 400;
        font-style: normal;
        padding-left: 0.25em;
        padding-right: 0.25em;
        font-size: 0.7em;
        height: 1cm;
    }
    

    .top-panel {
        height: 2cm;
    }
    
    .w2w-title {
        font-size: 1.9em;
        font-weight: 700;
    }

    .search {
        font-size: 1.1em;
        width: 65%;
        padding: 0.0cm;
        /* margin-left: 0.0cm; */
        /* margin-right: 0.5cm; */
        margin-left: 0.5cm;
        padding-right: 0.2cm;
        display: inline-block;
        /* font-size: 1.3em; */
        height: 0.7cm;
        text-indent: 0.1cm;
    }

    .clear-search-button {
        /* position: absolute; */
        right: 0.9cm;
        width: 0.5cm;
        height: 0.5cm;
        font-size: 0.4cm;
        /* font-weight: bolder; */
        /* text-align: center; */
        line-height: 0.5;
        /* font-weight: 800; */
        /* padding: 0; */
        border-radius: 0.25cm;
        /* border-width: 1px; */
        /* color: #ffffff; */
        /* background-color: #555555; */
        /* border-color: #555555; */
        /* display: none; */
    }

    /* .bowl_game_title
    {
        font-size: 0.7em;
    } */
    .fixed-element {
        height: 1.25cm;
        padding: 0px;
        /* padding-left: 10px; */
        /* padding-bottom: 5px; */
    }
    .fe_div_container {
        padding: 0px;
        padding-right: 0.1cm;
    }

    .filterbutton {
        height: 1cm;
        width: 1cm;
        /* margin-left: 2vmin; */
        /* padding: 0; */
        font-size: 0.6em;
        -webkit-box-align: center;
        /* display: inline-flex;
        justify-content: center;
        align-items: center; */
        border-radius: 0.2cm;
        -webkit-border-radius: 0.2cm;
      }
      .filterbutton:active {
        border-radius: 0.2cm;
        -webkit-border-radius: 0.2cm;
      }

      .watchability {
        margin-left: 0.3cm;
        text-align: center;
      }

      .br_mobile_only {
        display: inline; 
      }
      .away_team_logo_img {
        width: 0.7cm;
        height: 0.7cm;
        margin-right: 0.2cm;
      }
      .home_team_logo_img {
        width: 0.7cm;
        height: 0.7cm;
        margin-right: 0.2cm;
      }
      .home_team_name {
        display: none;
      }
      .away_team_name {
        display: none;
      }
      .away_team_shortname {
        flex-basis: 25%;
        display: inline;
      }
      .home_team_shortname {
        flex-basis: 25%;
        display: inline;
      }

      .list>li {
        padding-left: 0;
        padding-right: 0;
      }
      .list-container {
        /* top: 2cm;
        bottom: 1.25cm; */
        padding-top: 1.5cm;
        padding-bottom: 1.3cm;
        padding-left: 10px;
        padding-right: 10px;
      }
}

@media only screen and (max-device-height: 480px) and (orientation: landscape) {
    span {
        font-size: 1.3em; /*2em*/
        /* background-color: #ffeeff; */
      }

      .filterbutton {
        height: 12%;
        width: 7%;
        font-size: 1.5em;
      }

      input {
        height: 12%;
      }


}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,yBAAyB;EAC3B;;;EAGA;IACE,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB,EAAE,MAAM;EAC1B;;EAEA;IACE,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;;EAEzB;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,oCAAoC;EACtC;;;EAGA;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;;IAEE,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,gBAAgB,EAAE,MAAM;IACxB,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,eAAe;IACf;;4BAEwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,2BAA2B;IAC3B,aAAa;AACjB;AACA;IACI,cAAc;AAClB;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;;;;;;KAMG;;EAEH;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,aAAa;IACb,wBAAwB;IACxB,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;;;AAGF;IACI,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV;AACJ;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,cAAc;IACd,cAAc;IACd,OAAO;IACP,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,SAAS;IACT,6BAA6B;IAC7B,UAAU;IACV,cAAc;;;IAGd;;AAEJ;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB;;AAEJ;IACI,kBAAkB;IAClB;oBACgB;IAChB,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB,EAAE,+BAA+B;IACnD,qBAAqB;IACrB;;AAEJ;IACI,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,eAAe;IACf;AACJ;;;;AAIA,SAAS;AACT;CACC;QACO,gBAAgB,EAAE,MAAM;QACxB,+BAA+B;MACjC;;;MAGA;QACE,UAAU;MACZ;;MAEA;QACE,YAAY;MACd;AACN;;AAEA;;;;;GAKG;;AAEH,WAAW;AACX;IACI;QACI,cAAc,EAAE,MAAM;QACtB,+BAA+B;MACjC;IACF;QACI,WAAW;QACX,UAAU;QACV,gBAAgB;QAChB;MACF;;IAEF;QACI,aAAa;MACf;;MAEA;QACE,+CAA+C;QAC/C,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,qBAAqB;QACrB,gBAAgB;QAChB,UAAU;IACd;IACA;QACI,+CAA+C;QAC/C,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;QACpB,qBAAqB;QACrB,gBAAgB;QAChB,WAAW;IACf;;;IAGA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,UAAU;QACV,cAAc;QACd,wBAAwB;QACxB,yBAAyB;QACzB,kBAAkB;QAClB,oBAAoB;QACpB,qBAAqB;QACrB,sBAAsB;QACtB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;QACxB,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,gBAAgB;QAChB,yBAAyB;QACzB,wBAAwB;QACxB,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;QAChB,qBAAqB;QACrB,uBAAuB;QACvB,oBAAoB;QACpB,+BAA+B;QAC/B,2BAA2B;QAC3B,mBAAmB;IACvB;;IAEA;;;OAGG;IACH;QACI,cAAc;QACd,YAAY;QACZ,wBAAwB;QACxB,yBAAyB;IAC7B;IACA;QACI,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,UAAU;QACV,wBAAwB;QACxB,gBAAgB;QAChB,gBAAgB;QAChB,yBAAyB;QACzB;;8BAEsB;QACtB,oBAAoB;QACpB,4BAA4B;MAC9B;MACA;QACE,oBAAoB;QACpB,4BAA4B;MAC9B;;MAEA;QACE,kBAAkB;QAClB,kBAAkB;MACpB;;MAEA;QACE,eAAe;MACjB;MACA;QACE,YAAY;QACZ,aAAa;QACb,mBAAmB;MACrB;MACA;QACE,YAAY;QACZ,aAAa;QACb,mBAAmB;MACrB;MACA;QACE,aAAa;MACf;MACA;QACE,aAAa;MACf;MACA;QACE,eAAe;QACf,eAAe;MACjB;MACA;QACE,eAAe;QACf,eAAe;MACjB;;MAEA;QACE,eAAe;QACf,gBAAgB;MAClB;MACA;QACE;yBACiB;QACjB,kBAAkB;QAClB,qBAAqB;QACrB,kBAAkB;QAClB,mBAAmB;MACrB;AACN;;AAEA;IACI;QACI,gBAAgB,EAAE,MAAM;QACxB,+BAA+B;MACjC;;MAEA;QACE,WAAW;QACX,SAAS;QACT,gBAAgB;MAClB;;MAEA;QACE,WAAW;MACb;;;AAGN","sourcesContent":["body {\n    font-family: \"Barlow\";\n    background-color: #ffffff;\n  }\n\n  \n  button {\n    font-family: \"Barlow Semi Condensed\", system-ui;\n    font-weight: 400;\n    font-style: normal;\n    font-size: 2em;\n  }\n\n  span {\n    font-family: \"Barlow Semi Condensed\", system-ui;\n    font-weight: 400;\n    font-style: normal;\n    font-size: 1.5em; /*2em*/\n  }\n\n  input {\n    font-family: \"Barlow Semi Condensed\", system-ui;\n    font-weight: 400;\n    font-style: normal;\n    font-size: 2em;\n    height: 5vmin;\n  }\n\n  h1 {\n    font-size: 3em;\n  }\n\n  h2 {\n    font-family: \"Barlow\", system-ui;\n    font-size: 1.5em;\n    font-weight: 600;\n    font-style: italic;\n    color: #555;\n    border-bottom: 2px solid #ccc;\n    padding-bottom: 0.25em;\n    margin-block-start: 0.1em;\n    margin-block-end: 0.1em;\n\n  }\n\n  .list {\n    font-family: sans-serif;\n    margin: 0;\n    padding: 20px 0 0;\n  }\n\n  .list>li {\n    display: block;\n    background-color: #fff;\n    padding: 10px;\n    /* box-shadow: inset 0 2px 0 #ccc; */\n  }\n\n\n  .precontainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  .container {\n    display: flex;\n    justify-content: space-between;\n  }\n  .bowl_game_title\n  {\n    font-family: \"Barlow Semi Condensed\", system-ui;\n    font-weight: 500;\n    font-style: normal;\n    color: #999999;\n    font-size: 1.0em; /*2em*/\n    /* padding-top: 0.5em; */\n    padding-bottom: 0.5em;\n  }\n\n  .search {\n    font-size: 1.25em;\n    width: 92%;\n    height: 0.3cm; \n    padding: 0.25cm;\n    /* margin-left: 0.25cm;\n    margin-right: 0.25cm;\n    display: inline-block; */\n  }\n\n  .clear-search-button {\n    position: absolute;\n    right: 1.15cm;\n    width: 0.6cm;\n    height: 0.6cm;\n    font-size: 0.4cm;\n    text-align: center;\n    line-height: 0.6;\n    font-weight: 800;\n    padding: 0;\n    border-radius: 0.3cm;\n    border-width: 0px;\n    color: #ffffff;\n    background-color: #999999;\n    /* border-color: #333333; */\n    display: none;\n}\n.clear-search-button.show {\n    display: block;\n}\n  .home_team_name {\n    flex-basis: 25%;\n    /* adjust width */\n  }\n  .away_team_name {\n    flex-basis: 25%;\n  }\n  .away_team_shortname {\n    display: none;\n  }\n  .home_team_shortname {\n    display: none;\n  }\n\n  /* .home_team_mascot {\n    flex-basis: 25%;\n  }\n\n  .home_team_mascot {\n    flex-basis: 25%;\n  } */\n\n  .at_sign {\n    flex-basis: 5%;\n  }\n  .home_team_logo_img {\n    width: 40px;\n    height: 40px;\n    margin-right: 12px;\n  }\n  .away_team_logo_img {\n    width: 40px;\n    height: 40px;\n    margin-right: 12px;\n  }\n\n  .time {\n    flex-basis: 10%;\n    /* adjust width */\n  }\n  .timelink {\n    text-decoration: underline;\n    text-decoration-color: #d8d8d8;\n    color: inherit;\n  }\n\n  .watchability {\n    flex-basis: 15%;\n    /* adjust width */\n    margin-left: auto;\n    /* text-align: center; */\n    /* right-justify */\n  }\n\n  .br_mobile_only {\n    display: none; \n  }\n\n  .filterbutton {\n    height: 1.25cm;\n    width: 1.25cm;\n    /* margin-left: 2vmin; */\n    padding: 0;\n    margin: 0.1cm;\n    font-size: 1.0em;\n    -webkit-box-align: center;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 0.2cm;\n  }\n\n\n.changeWeekButton {\n    font-family: \"Barlow Semi Condensed\", system-ui;\n    font-weight: 400;\n    font-style: normal;\n    font-size: 2em;\n    background-color: #448811;\n    color: #ffffff\n}\n\n.weekLabelSpan {\n    font-family: \"Barlow Semi Condensed\", system-ui;\n    font-weight: 400;\n    font-style: normal;\n    padding-left: 0.25em;\n    padding-right: 0.25em;\n    font-size: 1.0em;\n    text-align: center;\n    width: 3cm;\n}\n\n.viewFilterSelect {\n    font-family: \"Barlow Semi Condensed\", system-ui;\n    font-weight: 400;\n    font-style: normal;\n    padding-left: 0.25em;\n    padding-right: 0.25em;\n    font-size: 1em;\n    height: 1.25cm;\n    border-radius: 0.2cm;\n    -webkit-border-radius: 0.2cm;\n    color: #111\n}\n\n.top-panel {\n    position: fixed;\n    display: flex; \n    flex-direction: row; \n    top: 0;\n    left: 0;\n    height: 2cm;\n    width: 100%;\n    background-color: #333576;\n    color: #eee;\n    padding: 0px;\n    padding-left: 0.5cm;\n    padding-right: 0.5cm;\n    margin: 0px;\n    align-items: center;\n    border-radius: 0;\n    z-index: 1;\n    }\n.fixed-element {\n    position: fixed;\n    display: flex;\n    bottom: 0;\n    /* top: 93%; */\n    height: 1.75cm;\n    left: 0;\n    width: 100%;\n    background-color: #ccc;\n    /* padding: 10px; */\n    /* padding-top: 10px; */\n    /* padding-bottom: 0px; */\n    margin: 0;\n    border-top: 1px solid #818181;\n    z-index: 1;\n    font-size: 2em;\n    \n    \n    }\n\n.fe_div_container {\n    display: inline-flex;\n    align-items: center;\n    height: 100%;\n    vertical-align: middle;\n    padding-right: 0.15cm;\n    /* padding: 15px; */\n    }\n    \n.list-container {\n    position: absolute;\n    /* top: 1.9cm;\n    bottom: 1.7cm; */\n    left: 0;\n    right: 0;\n    overflow-y: auto;\n    padding: 20px;\n    margin-top: 0.1cm;\n    padding-top: 1.5cm; /* remove default padding-top */\n    padding-bottom: 1.8cm;\n    }\n\n.w2w-title {\n    font-family:'Barlow'; \n    font-size:3em; \n    font-weight:700; \n    flex-basis: 60%; \n    display:inline-block\n}\n\n\n\n/* iPAD */\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n\tspan {\n        font-size: 1.5em; /*2em*/\n        /* background-color: #ccffff; */\n      }\n\n\n      .search {\n        width: 90%;\n      }\n\n      .clear-search-button {\n        right: 0.9cm;\n      }\n}\n\n/* @media only screen and (min-device-height: 768px) and (max-device-height: 1024px) and (orientation: landscape) {\n\tspan {\n        font-size: 1.5em; \n        background-color: #ccffff;\n      }\n} */\n\n/* iPhone */\n@media only screen and (max-device-width: 480px) and (orientation: portrait) {\n    span {\n        font-size: 1em; /*2em*/\n        /* background-color: #ffeeff; */\n      }\n    .filterbutton {\n        height: 2em;\n        width: 2em;\n        font-size: 1.7em;\n        color: #111\n      }\n\n    input {\n        height: 2.5em;\n      }\n\n      .weekLabelSpan {\n        font-family: \"Barlow Semi Condensed\", system-ui;\n        font-weight: 300;\n        font-style: normal;\n        padding-left: 0.25em;\n        padding-right: 0.25em;\n        font-size: 0.7em;\n        width: 2cm;\n    }\n    .viewFilterSelect {\n        font-family: \"Barlow Semi Condensed\", system-ui;\n        font-weight: 400;\n        font-style: normal;\n        padding-left: 0.25em;\n        padding-right: 0.25em;\n        font-size: 0.7em;\n        height: 1cm;\n    }\n    \n\n    .top-panel {\n        height: 2cm;\n    }\n    \n    .w2w-title {\n        font-size: 1.9em;\n        font-weight: 700;\n    }\n\n    .search {\n        font-size: 1.1em;\n        width: 65%;\n        padding: 0.0cm;\n        /* margin-left: 0.0cm; */\n        /* margin-right: 0.5cm; */\n        margin-left: 0.5cm;\n        padding-right: 0.2cm;\n        display: inline-block;\n        /* font-size: 1.3em; */\n        height: 0.7cm;\n        text-indent: 0.1cm;\n    }\n\n    .clear-search-button {\n        /* position: absolute; */\n        right: 0.9cm;\n        width: 0.5cm;\n        height: 0.5cm;\n        font-size: 0.4cm;\n        /* font-weight: bolder; */\n        /* text-align: center; */\n        line-height: 0.5;\n        /* font-weight: 800; */\n        /* padding: 0; */\n        border-radius: 0.25cm;\n        /* border-width: 1px; */\n        /* color: #ffffff; */\n        /* background-color: #555555; */\n        /* border-color: #555555; */\n        /* display: none; */\n    }\n\n    /* .bowl_game_title\n    {\n        font-size: 0.7em;\n    } */\n    .fixed-element {\n        height: 1.25cm;\n        padding: 0px;\n        /* padding-left: 10px; */\n        /* padding-bottom: 5px; */\n    }\n    .fe_div_container {\n        padding: 0px;\n        padding-right: 0.1cm;\n    }\n\n    .filterbutton {\n        height: 1cm;\n        width: 1cm;\n        /* margin-left: 2vmin; */\n        /* padding: 0; */\n        font-size: 0.6em;\n        -webkit-box-align: center;\n        /* display: inline-flex;\n        justify-content: center;\n        align-items: center; */\n        border-radius: 0.2cm;\n        -webkit-border-radius: 0.2cm;\n      }\n      .filterbutton:active {\n        border-radius: 0.2cm;\n        -webkit-border-radius: 0.2cm;\n      }\n\n      .watchability {\n        margin-left: 0.3cm;\n        text-align: center;\n      }\n\n      .br_mobile_only {\n        display: inline; \n      }\n      .away_team_logo_img {\n        width: 0.7cm;\n        height: 0.7cm;\n        margin-right: 0.2cm;\n      }\n      .home_team_logo_img {\n        width: 0.7cm;\n        height: 0.7cm;\n        margin-right: 0.2cm;\n      }\n      .home_team_name {\n        display: none;\n      }\n      .away_team_name {\n        display: none;\n      }\n      .away_team_shortname {\n        flex-basis: 25%;\n        display: inline;\n      }\n      .home_team_shortname {\n        flex-basis: 25%;\n        display: inline;\n      }\n\n      .list>li {\n        padding-left: 0;\n        padding-right: 0;\n      }\n      .list-container {\n        /* top: 2cm;\n        bottom: 1.25cm; */\n        padding-top: 1.5cm;\n        padding-bottom: 1.3cm;\n        padding-left: 10px;\n        padding-right: 10px;\n      }\n}\n\n@media only screen and (max-device-height: 480px) and (orientation: landscape) {\n    span {\n        font-size: 1.3em; /*2em*/\n        /* background-color: #ffeeff; */\n      }\n\n      .filterbutton {\n        height: 12%;\n        width: 7%;\n        font-size: 1.5em;\n      }\n\n      input {\n        height: 12%;\n      }\n\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
